import React from 'react';
import { Form, FormGroup, Label, Input } from 'reactstrap';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import SelectSearch, { fuzzySearch } from 'react-select-search';

const Excelpage2 = ({ handleChange, csvfile, onChangeExcel }) => (
    <Form>
        <FormGroup>
            <Input
                placeholder="upload file"
                type="file"
                id="csvfile"
                name="csvfile"
                accept=".csv, .xls"
                onChange={(event) => { onChangeExcel(event) }}
            />
        </FormGroup>
    </Form >
);
export default Excelpage2;